import { makeStyles } from '@material-ui/core/styles';
import { pxToRem } from '../../../../styles/themes/vad/constants';

const useStyles = makeStyles(theme => {
  const { marginLR, paddingLR } = theme.mixins;
  return {
    favGridWrapper: {
      minHeight: 'calc((var(--vh, 1vh) * 100) - 511px)',
      '& [data-locator="Favorite_Listing_layout"]': {
        minHeight: 'inherit',
      },
      '@media (min-width: 1024px) and (max-width: 1439px)': {
        minHeight: 'calc((var(--vh, 1vh) * 100) - 423px)',
      },
      '@media (min-width: 600px) and (max-width: 1023px)': {
        minHeight: 'calc((var(--vh, 1vh) * 100) - 380px)',
      },
      '@media (max-width: 569px)': {
        minHeight: 'calc((var(--vh, 1vh) * 100) - 397px)',
      },
    },
    listingLayoutWrappeer: {
      paddingTop: pxToRem(48),
      paddingBottom: pxToRem(48),
      ...paddingLR(theme.spacing(3), theme.spacing(3)),
      background: theme.mixins.milkWhite(200),
      minHeight: '60vh',

      [theme.breakpoints.up('lg')]: {
        display: 'flex',
        padding: `${theme.spacing(11)} 5.5%`,
        margin: 0,
      },
      '&.customBg': {
        [theme.breakpoints.down('md')]: {
          paddingTop: pxToRem(0),
          background: 'transparent'
        },
        '& .filterAlign': {
          marginTop: pxToRem(24),
          [theme.breakpoints.down('md')]: {
            marginTop: pxToRem(16),
            marginBottom: pxToRem(0),
          },
        },
        '& .noResultAlign': {
          marginTop: pxToRem(0),
          marginBottom: pxToRem(48),
          [theme.breakpoints.down('md')]: {
            marginBottom: pxToRem(25),
          },
        }
      },
    },
    filterSection: {
      [theme.breakpoints.up('lg')]: {
        flexBasis: '25%',
        position: 'relative',
        zIndex: 1,
      },
      [theme.breakpoints.down('lg')]: {
        '& section': {
          transform: 'none',
        },
      },
    },
    smartList: {
      [theme.breakpoints.up('lg')]: {
        flexBasis: '75%',
        ...marginLR(pxToRem(24), 0),
      },
      '& :last-child .smart-list-wrapper': {
        marginBottom: '0',
      },
    },
    filterdList: {
      overflowAnchor: 'none',
      [theme.breakpoints.up('lg')]: {
        flexBasis: '75%',
        ...marginLR(pxToRem(24), 0),
      },
    },
  };
});

export default useStyles;
